export default function InboxReducer(state = [], action) {
    
    switch (action.type) {
        case "SET_INBOX":
            return action.inbox;   
    
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/InboxReducer.js